
// ----------------------------------------------------------------------------------------------------
// Explicitly require the dependencies that will be bundled into "vendorCore-bundle" by webpack and
// expose these globally. Bootstrap is used on all pages, even server-side rendered pages.
// ----------------------------------------------------------------------------------------------------
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

